import get from 'lodash/get';
import Vue from 'vue';
import wx from 'weixin-js-sdk';
import { utils, chttp, apis } from '@/libs/interfaces';
import FloatAd from '@/components/app/adsense/float_ad.vue';

const HAPPY_ROOM_GUIDE_POPUP_IMG = 'https://qncweb.ktvsky.com/20260416/vadd/15d194d5fbc63e7a146e0b6c3de75075.png';
const HAPPY_ROOM_GUIDE_FLOAT_IMG = 'https://qncweb.ktvsky.com/20260309/vadd/959e0da54dc798d88004702bbf384ae8.png';
const HAPPY_ROOM_IOS_APP_URL = 'https://apps.apple.com/us/app/%E6%AC%A2%E4%B9%90%E6%AD%8C%E6%88%BF/id6748891695';
const HAPPY_ROOM_YYB_APP_URL = 'https://sj.qq.com/appdetail/com.thunder.tv?&from_wxz=1';
const HAPPY_ROOM_FLOAT_COOKIE_KEY = 'happy_room_float_keep_1h';
let HAPPY_ROOM_FLOAT_VM = null;

function isIOSDevice() {
  return /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
}

function jumpToHappyRoomAppStore({ action }) {
  try {
    Vue.$sendLog({
      event_type: 'click',
      event_name: '欢乐歌房入口点击',
      event_data: { action },
    });
  } catch (e) {
    // 忽略埋点异常
  }
  if (isIOSDevice()) {
    window.location.href = HAPPY_ROOM_IOS_APP_URL;
    setTimeout(() => {
      if (!document.hidden) {
        window.location.href = HAPPY_ROOM_YYB_APP_URL;
      }
    }, 2500);
  } else {
    window.location.href = HAPPY_ROOM_YYB_APP_URL;
  }
}

function showHappyRoomFloatAd({ action, $this, setCookie = false }) {
  // 仅首页展示
  if (!$this || !$this.$route || $this.$route.name !== 'home') return;

  // 首次展示时写 cookie，保活 1 小时；只要 cookie 存在就始终展示该浮窗
  if (setCookie) {
    utils.cookie.setCookie(1, 1 / 24, HAPPY_ROOM_FLOAT_COOKIE_KEY);
  } else if (!utils.cookie.getCookie(HAPPY_ROOM_FLOAT_COOKIE_KEY)) {
    return;
  }

  if (HAPPY_ROOM_FLOAT_VM) return;
  const Ctor = Vue.extend(FloatAd);
  const el = document.createElement('div');
  el.id = 'happy-room-float-ad';
  document.body.appendChild(el);
  HAPPY_ROOM_FLOAT_VM = new Ctor({
    // 手动 new 的组件需要注入 store/router，否则 Drag 等子组件取不到 this.$store
    store: $this.$store,
    router: $this.$router,
    propsData: {
      imgUrl: HAPPY_ROOM_GUIDE_FLOAT_IMG,
      from: 'paySuccess',
      name: '支付成功-欢乐歌房浮窗',
      position: 'left',
      // 强驻 1 小时：不提供关闭入口
      showClose: false,
      jumpToAppStore: true,
      clickAction: action,
      disableConfirmPopup: true,
      // 仅本浮窗：避免默认 bottom:700px 在小屏跑到顶部
      customStyle: {
        bottom: '250px',
      },
    },
  });
  HAPPY_ROOM_FLOAT_VM.$on('close', () => {
    try {
      HAPPY_ROOM_FLOAT_VM.$destroy();
      if (HAPPY_ROOM_FLOAT_VM.$el && HAPPY_ROOM_FLOAT_VM.$el.parentNode) {
        HAPPY_ROOM_FLOAT_VM.$el.parentNode.removeChild(HAPPY_ROOM_FLOAT_VM.$el);
      }
    } catch (e) {
      // ignore
    } finally {
      HAPPY_ROOM_FLOAT_VM = null;
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }
  });
  HAPPY_ROOM_FLOAT_VM.$mount(el);
}

function createShrinkAnim({ imgUrl, fromRect }) {
  if (!fromRect) return;
  const toSize = 120;
  const toLeft = 28;
  // 目标位置：与本次“欢乐歌房浮窗”一致
  const toBottom = 250;
  const toTop = Math.max(0, window.innerHeight - toBottom - toSize);

  const el = document.createElement('img');
  el.src = imgUrl;
  el.style.position = 'fixed';
  el.style.zIndex = '10001';
  el.style.left = `${fromRect.left}px`;
  el.style.top = `${fromRect.top}px`;
  el.style.width = `${fromRect.width}px`;
  el.style.height = `${fromRect.height}px`;
  el.style.borderRadius = '20px';
  el.style.transition = 'all 380ms cubic-bezier(0.2, 0.8, 0.2, 1)';
  el.style.transformOrigin = 'center center';
  el.style.pointerEvents = 'none';

  document.body.appendChild(el);
  requestAnimationFrame(() => {
    el.style.left = `${toLeft}px`;
    el.style.top = `${toTop}px`;
    el.style.width = `${toSize}px`;
    el.style.height = `${toSize}px`;
    el.style.opacity = '0.9';
    el.style.transform = 'scale(0.98)';
  });

  const cleanup = () => {
    el.removeEventListener('transitionend', cleanup);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  };
  el.addEventListener('transitionend', cleanup);
  setTimeout(cleanup, 600);
}

function getRaiseMessageMainImgRect() {
  try {
    const img = document.querySelector('.msgbox-wrapper .msgbox-content .click-action img');
    if (!img || typeof img.getBoundingClientRect !== 'function') return null;
    return img.getBoundingClientRect();
  } catch (e) {
    return null;
  }
}

function showHappyRoomGuidePopup({ action, $this }) {
  let closed = false;
  const closeToFloat = () => {
    if (closed) return;
    closed = true;
    const rect = getRaiseMessageMainImgRect();
    Vue.$RaiseMessage.close();
    createShrinkAnim({ imgUrl: HAPPY_ROOM_GUIDE_POPUP_IMG, fromRect: rect });
    setTimeout(() => showHappyRoomFloatAd({ action, $this, setCookie: true }), 380);
  };

  Vue.$RaiseMessage.alert(HAPPY_ROOM_GUIDE_POPUP_IMG, '', {
    showTopAgreement: false,
    // 点击图片：直接引导下载欢乐歌房
    callback: () => jumpToHappyRoomAppStore({ action }),
    // 手动关闭：缩小成浮窗
    closeCallback: closeToFloat,
  });
}

const routeExcludes = [ // 显示骨架屏的路由
  'home',
  'photov2',
  'photo',
  'mv',
  'bless_sort',
  'allTop',
  'classify_singer',
];
const loadingExcludes = [ // 取消公共loading的页面
  ...routeExcludes,
  'ordered',
  'search',
  'topList',
  'top',
  'singer',
  'guess_like',
];
const GOLD_OPENVIP = {
  vipSuccess: {
    num: 990,
    entrance: 'openvipsucces', // 会员开通成功金主弹窗
  },
};
const VIP_INFO = [{
  dispatchName: 'openOneVip',
  fromName: '一日会员',
  tpKey: 'one',
}, {
  dispatchName: 'openVip',
  fromName: '会员',
  tpKey: '',
}];

export default {
  // 欢乐歌房浮窗：cookie 存在则在首页强驻展示
  ensureHappyRoomFloatAd($this, action = 'cookie-keep-1h') {
    try {
      showHappyRoomFloatAd({ action, $this, setCookie: false });
    } catch (e) {
      // ignore
    }
  },
  listenAndroidKeyboardToggle(onShow, onHide) {
    // 针对 android 机型
    // 通过窗口高度的变化来监听键盘的收起和出现
    const windowInnerHeightNoKeyboard = window.innerHeight;
    const windowInnerHeightHasKeyboard = windowInnerHeightNoKeyboard;
    if ((/(Android)\s+([\d.]+)/i).test(window.navigator.userAgent)) {
      window.addEventListener('resize', () => {
        if (window.innerHeight < windowInnerHeightNoKeyboard && onShow) {
          onShow(windowInnerHeightNoKeyboard);
        }
        if (window.innerHeight >= windowInnerHeightHasKeyboard && onHide) {
          onHide();
        }
      });
    }
  },
  isAndroid() {
    if ((/(Android)\s+([\d.]+)/i).test(window.navigator.userAgent)) {
      return true;
    }
    return false;
  },
  rnd(n, m) { // 区间随机整数
    return Math.floor(Math.random() * (m - n + 1) + n);
  },
  getUrlPrem(key, url) {
    const search = url || window.location.href;
    const pattern = new RegExp(`[?&]${key}=([^&]+|\\w+)`, 'g');
    const matcher = pattern.exec(search);
    let items = null;
    if (matcher !== null) {
      try {
        items = decodeURIComponent(decodeURIComponent(matcher[1]));
      } catch (e) {
        try {
          items = decodeURIComponent(matcher[1]);
        } catch (error) {
          items = matcher[1];
          console.log(error);
        }
      }
    }
    return items;
  },
  loadJS(url, callback) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.src = url;
    document.onreadystatechange = () => {
      if (document.readyState === 'complete' && callback) {
        callback();
      }
    };
    head.appendChild(script);
  },
  skeletonCheckRoute(path, payload) {
    const reg = /^\S*\/thunder\/(\w*)(\/|\?)?\S*$/;
    const result = get(path.match(reg), 1);
    if (!result) return;
    if (payload === 'getPath') return result;
    if (payload === 'ajax') {
      return loadingExcludes.includes(result);
    }
    return routeExcludes.includes(result);
  },
  showGoldModal(pageName) {
    Vue.$sendLog({
      event_type: 'show',
      event_name: '金主开通成功弹窗',
      event_data: {
        name: '曝光',
        page: pageName,
      },
    });
    Vue.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20210329/vadd/9f580076f70e19dae42e4fa7a725dfda.png', '', {
      callback: () => {
        Vue.$sendLog({
          event_type: 'click',
          event_name: '点击',
          event_data: {
            name: '金主开通成功弹窗',
            page: pageName,
          },
        });
      },
      restStyle: {
        img: {
          width: '85.6vw',
        },
      },
    });
  },
   // 单人包场成功弹窗
  showSRModal(pageName, imgurl = 'https://qncweb-back1.ktvsky.com/20220602/other/835f22e156ce94178920785c5ba341e6.png') {
    if (pageName) {
        Vue.$sendLog({
            event_type: 'show',
            event_name: '单人包场开通成功弹窗',
            event_data: {
              name: '曝光',
              page: pageName,
            },
          });
    }
    Vue.$RaiseMessage.alert(imgurl, '', {
      callback: () => {
        if (pageName) {
            Vue.$sendLog({
                event_type: 'click',
                event_name: '点击',
                event_data: {
                  name: '单人包场开通成功弹窗',
                  page: pageName,
                },
              });
        }
      },
      restStyle: {
        img: {
          width: '85.6vw',
        },
      },
    });
  },
  VipShowToast(payload, fromName) {
    const { $this } = payload;
    const $State = $this.$store.state;
    const { title } = $this.$route.meta;
    Vue.$sendLog({
      event_type: 'show',
      event_name: `${fromName}|${title}页`,
      event_data: {
        action: '开通plus会员弹窗',
      },
    });
    Vue.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20210422/vadd/67241144d2043d642997aa7370022c00.png', '', {
      restStyle: {
        clickArea: {
          position: 'relative',
        },
      },
      callback: () => {
        this.buyVipPlus({
          ...payload,
          showToast: false,
        });
        Vue.$sendLog({
          event_type: 'click',
          event_name: `${fromName}|${title}页`,
          event_data: {
            name: '开通plus会员弹窗',
            action: '立即开通',
          },
        });
      },
      vipInfo: {
        pay_fee: $this.payPrice,
        isOneVip: $State.isGrayscale,
      },
      closeImg: require('@/views/vip/static/plus/vip_close.png'),
    });
  },
  buyVipPlus(payload) {
    const { $this } = payload;
    const $State = $this.$store.state;
    let vipInfo = {};
    let pay_enter = payload.pay_enter || $this.$route.query.fromType || 'unkown';
    let dispatchName = 'experimentVip'; // 体验会员5.9的套餐
    const ISVIP = $State.is_vip
    if (payload.vipIndex) {
      vipInfo = VIP_INFO[payload.vipIndex];
    } else {
      vipInfo = $State.isGrayscale ? VIP_INFO[0] : VIP_INFO[1];
      if (payload.pay_enter && payload.pay_enter.includes('daytq')) {
        pay_enter = `${vipInfo.tpKey}${payload.pay_enter}`;
      }
    }
    if (payload.showToast) {
      this.VipShowToast(payload, vipInfo.fromName);
      return;
    }
    pay_enter = pay_enter.includes('_role') ? pay_enter : `${pay_enter}_${$State.role}`
    let params = {
      callback: () => {
        Vue.$sendLog({
          event_type: 'click',
          event_name: $this.$route.path,
          event_data: {
            data: $this.$route.query.fromType,
          },
        });
        Vue.$sendLog({
          event_type: 'click',
          event_name: '会员弹窗支付成功',
          event_data: {
            num: Number(utils.cookie.getCookie('closeToastNum') || 0) + 1,
          },
        });
        if (payload.memberId === 4 || payload.memberId === 108) {
          $this.$store.commit('SAVE_IS_PLUS_VIP', true);
        }
        $this.$store.dispatch('getUserRole')
        if ($this.$route.name === 'home') { // 因为首页的弹窗是根据getHomeConfig显示的
          $this.$store.dispatch('getIsVip');
        } else {
          $this.$store.dispatch('getHomeConfig');
        }
        if ($State.have_gift) {
          $this.$store.dispatch('sendSpecialEffict');
        }
        $this.$store.dispatch('getUserInfo');
        Vue.$sendLog({
          event_type: 'show',
          event_name: `${vipInfo.fromName || pay_enter}开通页`,
          event_data: {
            action: '会员开通成功弹窗',
          },
        });
        if (get(payload, 'vipSongInfo.songid')) { // VIP歌曲收入来源细分
          Vue.$sendLog({
            event_type: 'click',
            event_name: 'vip歌曲弹窗支付',
            event_data: {
              type: payload.vipSongInfo.type,
              music_name: payload.vipSongInfo.music_name,
              songid: payload.vipSongInfo.songid,
              pay_fee: payload.pay_fee,
              route: $this.$route.path,
            },
          });
        }
        if ($this.$route.name === 'vipPlus') {
          if ($State.isMinProgram) {
            wx.miniProgram.redirectTo({
              url: `/pages/webview/index?route=${encodeURIComponent('/thunder/openvip?fromType=vipPlus')}`,
            })
            return
          }
          $this.$router.push('/thunder/openvip?fromType=vipPlus');
        }
        if (payload.closeToast) {
          if (payload.callback) {
            payload.callback();
          }
          return;
        }
        // 赠送好友支付成功
        if (payload.isChooseGiveFriend) {
          setTimeout(() => {
            $this.$router.push(`/thunder/givevip?orderId=${$State.charge.order_id}&pkgLevel=${$State.vip.pkgLevel}`);
          }, $this.$store.state.isMinProgram ? 2000 : 0);
          $this.$store.commit('SAVE_HOME_TOAST', false);
          $this.$store.commit('SET_VIP_PACKAGES_TOAST');
          Vue.$RaiseMessage.close(true);
          Vue.$RaiseNewPayment({ action: 'close' });
          Vue.$RaisePaymentMessage({ action: 'close' });
          Vue.$RaiseFocusMessage({ action: 'close' });
          if (typeof payload.giveFriendSuccess === 'function') {
            payload.giveFriendSuccess()
          }
          return
        }
        if ($this.$route.query.fromType === '90houExpired' && !ISVIP) {
        // 「90后盒子&&非VIP」开通三档会员成功弹窗统一更换为新弹窗
        // 需求文档：https://m2miovoqda.feishu.cn/wiki/wikcnG8q0Xe6Du8FCLVllhd4T8D
          Vue.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20211229/vadd/83e5abd65f2509ff6c13cf2ffa5d5d3d.png', '', {
            callback: () => {
              Vue.$sendLog({
                event_type: 'click',
                event_name: '开通会员成功点击进入点歌台',
                event_data: {
                  data: '90后过期',
                },
              });
              $this.$router.push('/thunder/home');
            },
          })
        } else {
          if (!payload.disableDialog) {
            if (!$State.bind_status) {
              $this.$router.push('/thunder/help/scode?from=paySuccess')
              return
            }
            // 原有的弹窗
            const showOriginalDialog = () => {
              Vue.$sendLog({
                event_type: 'show',
                event_name: '支付成功弹窗展示',
                event_data: {
                  data: '照片上屏',
                  type: $State.photoPath.label,
                },
              });
              Vue.$RaiseMessage.alert('https://qncweb.ktvsky.com/20250327/vadd/1369b9f54a4cc254f3b7db6d704a3b5d.png', '', {
                showTopAgreement: false,
                callback: () => {
                  Vue.$sendLog({
                    event_type: 'show',
                    event_name: '支付成功弹窗点击',
                    event_data: {
                      data: '照片上屏',
                      type: $State.photoPath.label,
                    },
                  });
                  if ($State.bless_path.includes('blessv1') && $this.$route.name === 'interact') return;
                  if ($State.bless_path.includes('blessv1')) {
                    $this.$router.push('/thunder/interact');
                  } else {
                    const path = $State.photo_path_new
                    $this.$jump(
                      path,
                      'paysuccess'
                    )
                  }
                  $this.$RaiseMessage.close()
                },
                closeImg: 'https://qncweb-back1.ktvsky.com/20240417/other/9807821cb26f9bf9f2602280600df4e6.png',
                restStyle: {
                  img: {
                    width: '74vw',
                    position: 'relative',
                    top: '-6vw'
                  },
                },
                clickButtonConfig: {
                  img: 'https://qncweb.ktvsky.com/20250327/vadd/f877310e59add7e3a7e97776e8509942.png',
                  width: '45.3vw',
                  top: '100vw',
                  animateName: 'breath',
                },
                handEffectConfig: {
                  img: 'https://qncweb.ktvsky.com/20250327/vadd/1c7d34ab70be888b1d1826f5d20b3857.png',
                  width: '13.5vw',
                  top: '108vw',
                  left: '58vw',
                },
              });
            };

            // 将photoData变量提取到外部作用域
            let photoData = null;

            // 新增的弹窗
            const showNewPhotoDialog = () => {
              Vue.$sendLog({
                event_type: 'show',
                event_name: '支付成功照片询问弹窗展示',
                event_data: {
                  data: '照片上屏询问',
                },
              });

              // 国庆主题
              const { role } = $State;
              let imageUrl = 'https://qncweb.ktvsky.com/20250516/vadd/10260569262954c4fa587ce56785d449.png'; // 默认图片地址

              if (role === 'role1' || role === 'role3') {
                imageUrl = 'https://qncweb.ktvsky.com/20250925/vadd/28be3e9795d6161c03d9c0c8eada50fe.png';
              }

              Vue.$RaiseMessage.alert(imageUrl, '', {
                callback: () => {
                  Vue.$sendLog({
                    event_type: 'click',
                    event_name: '支付成功照片询问弹窗点击是',
                    event_data: {
                      data: '是',
                    },
                  });

                  // 点“是”后展示欢乐歌房浮窗（写 cookie 保活 1 小时）
                  setTimeout(() => {
                    showHappyRoomFloatAd({ action: '支付成功-娱乐弹窗-点击是', $this, setCookie: true });
                  }, 0);

                  // 调起支付，使用photoData中的参数
                  if (photoData && photoData.package && photoData.package.all && photoData.package.all.novip) {
                    $this.$store.dispatch('wxpay', {
                      params: {
                        unionid: $State.unionid,
                        openid: $State.openid,
                        pkg_id: photoData.package.all.novip.pkg_id,
                        entrance: `photoT_paySuccess_${$State.photoPath.entrance}`,
                      },
                      wxUrl: apis.privilegeWxpay,
                      elseData: {
                        callback: () => {
                          // 支付成功后跳转到娱乐页面
                          if ($State.bless_path.includes('blessv1')) {
                            $this.$router.push('/thunder/interact');
                          } else {
                            $this.$router.push($State.photo_interact_path_new);
                          }
                        }
                      }
                    });
                  } else {
                    console.error('无法获取照片套餐信息');
                  }
                },
                restStyle: {
                  img: {
                    width: '100vw',
                    position: 'fixed',
                    bottom: '0',
                    left: '0'
                  },
                  wrapper: {
                    alignItems: 'flex-end',
                  },
                  preciseCountdown: {
                    bottom: '88vw',
                    width: '100%',
                  }
                },
                showBreathBtns: true,
                showClose: false,
                preciseCountDown: 300000,
                closeCallback: () => {
                  Vue.$sendLog({
                    event_type: 'click',
                    event_name: '支付成功照片询问弹窗点击否',
                    event_data: {
                      data: '否',
                    },
                  });

                  // 点“否”后引导去「欢乐歌房」；关闭则缩成浮窗
                  setTimeout(() => {
                    showHappyRoomGuidePopup({ action: '支付成功-娱乐弹窗-点击否', $this });
                  }, 0);
                }
              });
            };

            // 检查用户是否有发照片权限
            const checkPhotoPrivilege = async () => {
              try {
                const photoParams = {
                  openid: $State.openid,
                  unionid: $State.unionid,
                };
                const res = await chttp.get(apis.photo_pagv3, { params: photoParams });
                const hasPrivilege = res.data.privilege;

                // 保存数据供后续使用
                photoData = res.data;

                if (hasPrivilege) {
                  // 有权限，显示原来的弹窗
                  showOriginalDialog();
                } else {
                  // 没有权限，显示新弹窗
                  showNewPhotoDialog();
                }
              } catch (error) {
                console.error('获取照片权限失败', error);
                // 出错时默认显示原弹窗
                showOriginalDialog();
              }
            };

            // 执行检查
            checkPhotoPrivilege();
          }
        }
        if (payload.callback) {
          payload.callback();
        }
      },
      cancelcallback: () => {
        if (payload.cancelcallback) {
          payload.cancelcallback();
        }

        // 互斥逻辑：如果当前有娱乐待支付信息，先清除
        const currentPendingPayment = $this.$store.state.pendingPayment;
        if (currentPendingPayment && currentPendingPayment.type === 'entertainment') {
          $this.$store.commit('SET_SHOW_PAY_TOAST', false);
        }

        $this.$store.commit('SET_SHOW_PAY_TOAST', true);
        $this.$store.commit('SET_PENDING_PAYMENT', payload);
      },
      cancelCloseCallBack: () => {
        if (payload.cancelCloseCallBack) {
          payload.cancelCloseCallBack();
        }
      },
      pay_enter,
      page_tp: payload.page_tp || pay_enter,
    };
    if (payload.pay_fee) { // 如果传memberId了，证明是老版或者一日会员的套餐
      params = {
        ...params,
        memberId: payload.memberId,
        pay_fee: payload.pay_fee,
      };
      dispatchName = vipInfo.dispatchName;
    }

    // 本地/测试：绕过支付流程，直接模拟“支付成功”
    // 用法：
    // - URL 带 ?mockPay=1
    // - 或 localStorage.setItem('mockPayVipPlus', '1')
    const mockPayFlag = payload.mockPay
      || $this?.$route?.query?.mockPay === '1'
      || (typeof localStorage !== 'undefined' && localStorage.getItem('mockPayVipPlus') === '1');
    if (process.env.NODE_ENV !== 'production' && mockPayFlag) {
      setTimeout(() => {
        if (params && typeof params.callback === 'function') params.callback();
      }, 0);
      return;
    }

    $this.$store.dispatch(dispatchName, params);
  },
  payGiveVip(payload, {
    memberId, pay_fee, pay_enter, isChooseGiveFriend
  }) {
    const { $this } = payload;
    this.buyVipPlus({
      memberId,
      pay_fee,
      $this,
      isChooseGiveFriend,
      pay_enter,
      showSuccessToast: !isChooseGiveFriend,
    });
  },
  payPlayDayVip(payload) {
    const { $this } = payload;
    this.buyVipPlus({
      memberId: 78,
      pay_fee: 990,
      $this,
      pay_enter: payload.pay_enter,
      closeToast: true,
      callback: () => {
        Vue.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20240416/other/b5593dbbcbaa6a0f8fce691888610443.png', '', {
          callback: () => {
            if ($this.$route.name === 'home') return;
            $this.$router.push('/thunder/home');
            Vue.$RaiseMessage.close()
          },
          closeImg: 'https://qncweb-back1.ktvsky.com/20240417/other/9807821cb26f9bf9f2602280600df4e6.png',
          restStyle: {
            img: {
              width: '100vw',
              position: 'relative',
              top: '-10vw'
            },
          },
          closeBtn: 'right: 6vw;top: -18vw',
        });
      }
    });
  },
  openFreeGold(payload) {
    const { $this } = payload;
    $this.$store.dispatch('buyFreeGold').then(() => {
        $this.$store.dispatch('getGoldBaochang')
        Vue.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20221104/vadd/990ffa55bfc1df407f64cba231ff1ffc.png', '', {
          callback: () => {
            Vue.$RaiseMessage.close()
          },
        });
    })
 },
  openGoldVip(payload) {
    const { $this } = payload;
    const entrance = payload.entrance || GOLD_OPENVIP[payload.name].entrance;
    $this.$store.dispatch('buyGoldBaochang', {
      entrance,
      pay_fee: $this.$store.state.goldPrice,
      callback: () => {
        $this.$store.dispatch('getGoldBaochang');
        $this.$store.commit('SET_VIP_PACKAGES_TOAST');
        if ($this.$route.name === 'interact') {
          this.showGoldModal('娱乐页');
          return;
        }
        if ($this.$store.state.blessPag) {
          this.showGoldModal('pag合集页');
          $this.$router.push('/thunder/pag/bless/2');
        } else {
          $this.$router.push('/thunder/interact?openGold=1');
        }
        $this.$store.commit('SET_GOLD_MODAL', true);
      },
    });
  },
  checkVipExpiredWithinDays(payload) {
    const { $this, days } = payload;

    if (!$this.vip_endtime) return false; // 无VIP时间，直接返回false
    const now = new Date();
    const endTime = new Date($this.vip_endtime.replace(/-/g, '/'));
    if (isNaN(endTime.getTime())) return false; // 时间格式错误

    const daysDiff = Math.ceil(endTime.getTime() - now.getTime()) / (1000 * 60 * 60 * 24); // 计算天数差
    // 判断逻辑：
    // 剩余天数判断（days > 0）
    if (days > 0) return daysDiff > days;
    // 过期天数判断（days <= 0）
    return daysDiff <= 0 && Math.abs(daysDiff) <= Math.abs(days);
  }
};
